import axios from 'axios';
import { useDispatch } from 'react-redux';
import { BASE_API_URL } from 'utils/const';

const API_URL = BASE_API_URL+'auth/';

export const login = async ({ email, password }) => {
  const response = await axios.post(API_URL + 'login', { email, password });
  if (response.data.access_token) {
    localStorage.setItem('token', JSON.stringify(response.data.access_token));
    localStorage.setItem('orgId', JSON.stringify(response.data.org));
  }
  return response.data;
};

export const validateToken = async () => {
  const token = JSON.parse(localStorage.getItem('token'));
  const response = await axios.post(API_URL + 'validate', { token });
  if (response.data.isValid) {
    return response.data;
  } else {
    return false;
  }
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('orgId');
};

export const getCurrentUserToken = () => {
  return JSON.parse(localStorage.getItem('token'));
};
